import { useEffect, useState } from "react";
import { graphqlRequest } from "../common/apiClient";

const MY_TENANT_COPILOT_QUERY = `
  query MyTenantCopilot {
    myTenant {
      tenant_id
      plan
      copilot_enabled
    }
  }
`;

export function useCopilotFeature() {
  const [state, setState] = useState({
    enabled: false,
    plan: "starter",
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await graphqlRequest(MY_TENANT_COPILOT_QUERY);
        const tenant = data?.myTenant;
        if (cancelled) return;
        setState({
          enabled: Boolean(tenant?.copilot_enabled),
          plan: tenant?.plan || "starter",
          loading: false,
        });
      } catch {
        if (!cancelled) {
          setState({ enabled: false, plan: "starter", loading: false });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
